import { Inject, Injectable } from '@angular/core';
import { TInputAppEnvironmentVars } from '@monorepo/types';

const WipPackerEndPoints = {
  SAVE: 'SAVE',
};

type TWipPackerEndPoints = typeof WipPackerEndPoints;
type TWipPackerEndPointsTypes = keyof TWipPackerEndPoints;
type TEnvVariables = TWipPackerEndPoints;

@Injectable({
  providedIn: 'root',
})
export class WipPackerEnvProvider {
  private env_vars!: TEnvVariables;
  private protocol = 'http';
  private service_host = '';
  private event_hub = '';
  constructor(@Inject('environment') ENV: TInputAppEnvironmentVars) {
    if (ENV.protocol != null) {
      this.protocol = ENV.protocol;
    }
    if (ENV.service_host != null) {
      this.service_host = ENV.service_host;
    }
    if (ENV.event_hub != null) {
      this.event_hub = ENV.event_hub;
    }

    this.registerVars();
  }

  registerVars() {
    const HOST_DOMAIN_WITH_PROTOCOL = this.protocol + this.service_host;

    this.env_vars = {
      SAVE: HOST_DOMAIN_WITH_PROTOCOL + this.event_hub + '/api/v3/event/save',
    };
  }

  getEnvVar(key: TWipPackerEndPointsTypes): string {
    return this.env_vars[key];
  }
}
